import { render, staticRenderFns } from "./ClaimRejection.vue?vue&type=template&id=4c043bf8"
import script from "./ClaimRejection.vue?vue&type=script&lang=js"
export * from "./ClaimRejection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports